import styled from '@emotion/styled';
import { rgba } from 'polished';
import { Link } from 'react-router-dom';

import ImgBgMainPc from '@/assets/images/lp/entry/bg_main_pc.png';
import ImgBgMainSp from '@/assets/images/lp/entry/bg_main_sp.png';
import ImgMainPcStopInv from '@/assets/images/lp/entry/img_main_pc_stop_invitation.png';
import ImgMainPcUpdMission from '@/assets/images/lp/entry/img_main_pc_upd_mission.png';
import ImgMainSpStopInv from '@/assets/images/lp/entry/img_main_sp_stop_invitation.png';
import ImgMainSpUpdMission from '@/assets/images/lp/entry/img_main_sp_upd_mission.png';
import ImgStepArrowPcIcon from '@/assets/images/lp/entry/img_step_arrow_pc.svg';
import ImgStepArrowSpIcon from '@/assets/images/lp/entry/img_step_arrow_sp.svg';
import ImgStepDotIcon from '@/assets/images/lp/entry/img_step_dot_pc.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Header = styled.header(() =>
  mq({
    height: '48px',
    padding: `10px 0 10px 15px`,
  }),
);

export const HeaderLogoLink = styled(Link)(() =>
  mq({
    display: 'flex',
    width: '110px',
    height: '28px',
    alignItems: 'center',
  }),
);

export const HeaderLogoImg = styled.img(() =>
  mq({
    width: '110px',
    height: '28px',
  }),
);

export const Main = styled.main(() =>
  mq({
    width: '100%',
    color: defaultTheme.text.default,
    textAlign: 'center',
    lineHeight: '1',
  }),
);

export const MainVisualArea = styled.div(() =>
  mq({
    display: 'flex',
    width: '100%',
    height: ['352px', '352px', '400px'],
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: [
      `url(${ImgBgMainSp})`,
      `url(${ImgBgMainSp})`,
      `url(${ImgBgMainPc})`,
    ],
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    marginBottom: ['24px', '24px', '40px', '40px'],
  }),
);

export const MainVisualStopInvitation = styled.div(() =>
  mq({
    display: 'flex',
    width: '100%',
    height: ['352px', '352px', '400px'],
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: [
      `url(${ImgMainSpStopInv})`,
      `url(${ImgMainSpStopInv})`,
      `url(${ImgMainPcStopInv})`,
    ],
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    marginBottom: ['24px', '24px', '40px', '40px'],
  }),
);

export const MainVisualMissionUpdated = styled.div(() =>
  mq({
    display: 'flex',
    // width: '100%',
    height: ['352px', '352px', '400px'],
    justifyContent: 'center',
    alignItems: 'center',
    backgroundImage: [
      `url(${ImgMainSpUpdMission})`,
      `url(${ImgMainSpUpdMission})`,
      `url(${ImgMainPcUpdMission})`,
    ],
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    marginBottom: ['24px', '24px', '40px', '40px'],
  }),
);

export const RebornText = styled.h1(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    lineHeight: '1.5',
    padding: `0 ${defaultTheme.spacing.xxl}`,
    marginBottom: defaultTheme.spacing.xxl,
    '&>span': {
      margin: `0 ${defaultTheme.spacing.xs}`,
      paddingBottom: defaultTheme.spacing.xs,
      background: `linear-gradient(transparent 40%, ${rgba(
        defaultTheme.background.primary,
        0.2,
      )} 1%)`,
    },
  }),
);

export const ButtonSection = styled.section(() =>
  mq({
    marginBottom: ['36px', '36px', '64px', '64px'],
    padding: `0 ${defaultTheme.spacing.xxl}`,
  }),
);

export const ButtonAppealText = styled.div(
  (props: { color?: keyof typeof defaultTheme.color }) =>
    mq({
      fontSize: [
        defaultTheme.font.size.s,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
        defaultTheme.font.size.m,
      ],
      fontWeight: 'bold',
      color: props.color
        ? defaultTheme.color[props.color]
        : defaultTheme.color.secondary,
      marginBottom: defaultTheme.spacing.l,
    }),
);

export const LinkButton = styled(Link)(() =>
  mq({
    width: ['100%', '100%', '560px', '560px'],
    padding: defaultTheme.spacing.xxl,
    margin: '0 auto',
    color: defaultTheme.color.white,
    fontSize: defaultTheme.font.size.xxl,
    fontWeight: 'bold',
    display: 'block',
    borderRadius: '100vh',
    background: 'linear-gradient(to right, #337ACC, #50CFE6)',
    ...hoverOpacity,
  }),
);

export const Title = styled.h2(
  (props: { color?: keyof typeof defaultTheme.color }) =>
    mq({
      color: props.color
        ? defaultTheme.color[props.color]
        : defaultTheme.color.secondary,
      fontSize: ['32px', '32px', '40px', '40px'],
      fontWeight: 'bold',
      lineHeight: '1.2',
    }),
);

export const CharmSection = styled.section(() =>
  mq({
    backgroundColor: '#FFE100',
    padding: [
      `40px ${defaultTheme.spacing.xxl}`,
      `40px ${defaultTheme.spacing.xxl}`,
      `64px ${defaultTheme.spacing.xxl}`,
      `64px ${defaultTheme.spacing.xxl}`,
    ],
    '&>h2': {
      marginBottom: ['24px', '24px', '40px', '40px'],
    },
  }),
);

export const CharmWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      '100%',
      '100%',
      'repeat(2, minmax(360px, 508px))',
      'repeat(2, 508px)',
    ],
    gap: defaultTheme.spacing.xxl,
    justifyContent: 'center',
    marginBottom: defaultTheme.spacing.xxl,
  }),
);

export const CharmContent = styled.div(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.xxl,
    '& > div:first-of-type': {
      marginBottom: defaultTheme.spacing.xxl,
    },
  }),
);

export const CharmHeadlineWrapper = styled.div(() =>
  mq({
    position: 'relative',
    textAlign: 'left',
  }),
);

export const CharmSubHeadline = styled.div(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const CharmHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
    lineHeight: '1.5em',
    color: defaultTheme.color.primary,
  }),
);

export const CharmPopularImg = styled.img(() =>
  mq({
    position: 'absolute',
    top: '-9px',
    left: '144px',
    width: '72px',
    height: 'auto',
  }),
);

export const CharmDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    textAlign: 'left',
    '>span': {
      color: defaultTheme.color.primary,
      fontWeight: 'bold',
    },
  }),
);

export const CharmCaution = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    lineHeight: 1,
  }),
);

export const CampaignSection = styled.section(() =>
  mq({
    width: '100%',
    backgroundColor: '#FFE100',
    padding: ['40px 0', '40px 0', '64px 0', '64px 0'],
    marginBottom: ['24px', '24px', '48px', '48px'],
  }),
);

export const RibbonImg = styled.img(() =>
  mq({
    width: 'auto',
    height: ['38px', '38px', '48px', '48px'],
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const CampaignImgWrapper = styled.div(() =>
  mq({
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    marginTop: defaultTheme.spacing.l,
    marginBottom: [defaultTheme.spacing.l, defaultTheme.spacing.l, '0', '0'],
    '& > div': {
      paddingTop: ['450px', '450px', '450px', '590px'],
      '& img': {
        minWidth: '320px',
        maxWidth: ['500px', '500px', '1040px'],
        height: ['450px', '450px', '100%'],
        objectFit: ['cover', 'cover', 'contain'],
        margin: '0 auto',
      },
    },
  }),
);

export const CampaignImg = styled.img(() =>
  mq({
    width: '100%',
    minWidth: '568px',
    height: 'auto',
  }),
);

export const CampaignCaution = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    padding: `0 ${defaultTheme.spacing.xxl}`,
  }),
);

export const AboutArea = styled.div(() =>
  mq({
    padding: defaultTheme.spacing.l,
    marginBottom: ['24px', '24px', '48px', '48px'],
    '&>h2': {
      marginBottom: '40px',
    },
  }),
);

export const AboutDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
  }),
);

export const MeritSection = styled.section(() =>
  mq({
    backgroundColor: defaultTheme.background.lightGray,
    padding: [
      `40px ${defaultTheme.spacing.xxl}`,
      `40px ${defaultTheme.spacing.xxl}`,
      `64px ${defaultTheme.spacing.xxl}`,
      `64px ${defaultTheme.spacing.xxl}`,
    ],
    '&>h2': {
      marginBottom: ['24px', '24px', '40px', '40px'],
    },
  }),
);

export const MeritWrapper = styled.ul(() =>
  mq({
    display: 'grid',
    width: '100%',
    maxWidth: '1040px',
    gap: defaultTheme.spacing.xxl,
    justifyContent: 'center',
    margin: '0 auto',
  }),
);

export const MeritContent = styled.li(() =>
  mq({
    display: 'flex',
    flexDirection: ['column', 'column', 'row', 'row'],
    alignItems: 'center',
    backgroundColor: defaultTheme.background.white,
    padding: defaultTheme.spacing.xxl,
    '& > div:first-of-type': {
      flexShrink: 0,
      marginRight: [
        '0',
        '0',
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
      ],
      marginBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '0',
        '0',
      ],
    },
  }),
);

export const MeritHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
    lineHeight: '1.5em',
    textAlign: ['center', 'center', 'left', 'left'],
  }),
);

export const MeritDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    textAlign: 'left',
  }),
);

export const StepSection = styled.section(() =>
  mq({
    padding: [
      `40px ${defaultTheme.spacing.l}`,
      `40px ${defaultTheme.spacing.l}`,
      '64px 0',
      '64px 0',
    ],
    '&>h2': {
      marginBottom: [
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
        '40px',
        '40px',
      ],
    },
  }),
);

export const StepRedHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    color: defaultTheme.color.primary,
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const StepWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: [
      'inherit',
      'inherit',
      '184px 64px 184px 64px 184px',
      '184px 96px 184px 96px 184px',
    ],
    gap: ['8px', '8px', '16px', '32px'],
    justifyContent: 'center',
    marginBottom: ['24px', '24px', '32px', '32px'],
  }),
);

export const StepContent = styled.div(() =>
  mq({
    display: 'flex',
    flexDirection: ['row', 'row', 'column', 'column'],
    alignItems: 'center',
    width: ['100%', '100%', '184px', '184px'],
    '& > div:first-of-type': {
      marginBottom: [
        '0',
        '0',
        defaultTheme.spacing.xxl,
        defaultTheme.spacing.xxl,
      ],
    },
  }),
);

export const StepContentBody = styled.div(() =>
  mq({
    marginLeft: [defaultTheme.spacing.l, defaultTheme.spacing.l, '0', '0'],
    textAlign: ['left', 'left', 'center', 'center'],
  }),
);

export const StepHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.xl,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const StepDescription = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
  }),
);

export const StepDotIconWrapper = styled.div(() =>
  mq({
    display: ['flex', 'flex', 'block', 'block'],
    justifyContent: ['center', 'center', 'inherit', 'inherit'],
    alignItems: ['center', 'center', 'inherit', 'inherit'],
    height: ['24px', '24px', 'inherit', 'inherit'],
    width: ['72px', '72px', 'inherit', 'inherit'],
  }),
);

export const StepDotIcon = styled.i(() =>
  mq({
    display: 'block',
    width: ['24px', '24px', '64px', '96px'],
    height: ['8px', '8px', '12px', '16px'],
    backgroundImage: `url(${ImgStepDotIcon})`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    transform: ['rotateZ(90deg)', 'rotateZ(90deg)', 'inherit', 'inherit'],
    margin: ['0', '0', '96px 0 0', '96px 0 0'],
  }),
);

export const StepArrowIcon = styled.i(() =>
  mq({
    display: 'block',
    width: ['327px', '327px', '745px', '876px'],
    maxWidth: '100%',
    height: '18px',
    backgroundImage: [
      `url(${ImgStepArrowSpIcon})`,
      `url(${ImgStepArrowSpIcon})`,
      `url(${ImgStepArrowPcIcon})`,
      `url(${ImgStepArrowPcIcon})`,
    ],
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    margin: `0 auto ${defaultTheme.spacing.xxl}`,
  }),
);

export const StepAfterAgeConfirm = styled.p(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const StepComplete = styled.p(() =>
  mq({
    fontSize: '28px',
    fontWeight: 'bold',
    color: defaultTheme.color.primary,
  }),
);

export const BottomMainVisualSection = styled.section(() =>
  mq({
    display: 'flex',
    width: '100%',
    height: [null, null, '336px', '336px'],
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: defaultTheme.color.primary,
  }),
);

export const AboutCampaignSection = styled.section(() =>
  mq({
    backgroundColor: defaultTheme.background.lightGray,
    padding: [
      `40px ${defaultTheme.spacing.l}`,
      `40px ${defaultTheme.spacing.l}`,
      `64px ${defaultTheme.spacing.xxl}`,
      `64px ${defaultTheme.spacing.xxl}`,
    ],
    '& > h2:not(first-of-type)': {
      marginTop: ['48px', '48px', '54px'],
    },
  }),
);

export const AboutCampaignTitle = styled.h2(() =>
  mq({
    fontSize: defaultTheme.font.size.l,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const AboutCampaignWrapper = styled.div(() =>
  mq({
    maxWidth: '1040px',
    textAlign: 'left',
    margin: '0 auto',
  }),
);

export const AboutCampaignHeadLine = styled.h3(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.m,
    '&:before': {
      content: '"◆"',
    },
  }),
);

export const AboutCampaignContent = styled.p(
  (props: { marginBottom?: keyof typeof defaultTheme.spacing }) =>
    mq({
      fontSize: defaultTheme.font.size.m,
      lineHeight: '1.5em',
      marginBottom:
        props.marginBottom && defaultTheme.spacing[props.marginBottom],
    }),
);

export const AboutCampaignCaution = styled.small(() =>
  mq({
    display: 'block',
    fontSize: defaultTheme.font.size.xs,
    marginBottom: defaultTheme.spacing.xxl,
    paddingLeft: '1em',
    position: 'relative',
    '&:before': {
      content: '"※"',
      position: 'absolute',
      left: '0',
      top: '0',
    },
  }),
);

export const AboutCampaignCautionWrapper = styled.ul(() =>
  mq({
    '&>li': {
      fontSize: defaultTheme.font.size.m,
      lineHeight: '1.5em',
      paddingLeft: '1em',
      position: 'relative',
      '&:not(:last-of-type)': {
        marginBottom: defaultTheme.spacing.s,
      },
      '&:before': {
        content: '"・"',
        position: 'absolute',
        left: '0',
        top: '0',
      },
    },
  }),
);

export const NotCoveredWrapper = styled.ul(() =>
  mq({
    marginTop: defaultTheme.spacing.s,
    '&>li': {
      fontSize: defaultTheme.font.size.m,
      lineHeight: '1.5em',
      paddingLeft: '1em',
      position: 'relative',
      '&:not(:last-of-type)': {
        marginBottom: defaultTheme.spacing.s,
      },
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '0',
        top: '0',
      },
    },
  }),
);

export const Footer = styled.footer(() =>
  mq({
    display: 'block',
    width: '100%',
    height: ['376px', '376px', '338px', '338px'],
    backgroundColor: defaultTheme.background.secondary,
    textAlign: 'center',
    padding: '32px 24px',
  }),
);

export const FooterLogoLink = styled(Link)(() =>
  mq({
    width: '125px',
    height: '32px',
    margin: '32px auto',
  }),
);

export const FooterLogoImg = styled.img(() =>
  mq({
    width: 'auto',
    height: '32px',
  }),
);

export const FooterLink = styled.div(() =>
  mq({
    color: defaultTheme.color.grayScale.mediumLight,
    fontSize: defaultTheme.font.size.s,
    display: 'flex',
    justifyContent: 'center',
    margin: '40px 0',
  }),
);

export const FooterLinkList = styled.ul(() =>
  mq({
    display: 'flex',
    flexWrap: 'wrap',
    gap: defaultTheme.spacing.xxl,
    '&>li': {
      width: 'max-contents',
    },
  }),
);

export const CopyRight = styled.small(() =>
  mq({
    display: 'block',
    color: defaultTheme.color.white,
    fontSize: defaultTheme.font.size.s,
    marginTop: '32px',
  }),
);

export const FloatingArea = styled.div((props: { isShow: boolean }) =>
  mq({
    display: props.isShow ? 'block' : 'none',
    width: '100%',
    textAlign: 'center',
    padding: `${defaultTheme.spacing.l} ${defaultTheme.spacing.xxl}`,
    backgroundColor: rgba('#000000', 0.8),
    position: 'fixed',
    zIndex: '100',
    bottom: '0',
  }),
);
